import * as taskName from './task-name'

import { createUIDefinition } from '../default-task-definition'
import { selectProcessContext } from '../../../state/instance-detail/selector'
import * as processUI from '../../process-ui'


export default createUIDefinition({
    taskName: taskName.SHIP_RETAINER,
    widgetList: [
        {
            component: processUI.SHIPMENT_LIST_WIDGET_CONTAINER,
        },
        {
            component: processUI.DELIVERY_TRACKING_WIDGET,
        },
    ],
    actionList: [],
    taskValidatorSelector: [
        selectProcessContext,
    ],
    taskValidator: (task, processInstance, taskName, eventName, context) => {
        if (eventName !== 'retainer_shipped') {
            return null
        }

        const messageList = []

        const trackingNumber = context.trackingNumber
        if (!trackingNumber) {
            // messageList.push(createValidationMessage('Please add the tracking number before proceeding.', 'checkDeliveryTracking.checkDeliveryTracking'));
        }
        return messageList
    },
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/retainer/ship-retainer.js